export const createCourse = (payload?: any) => ({
    type: "@saga/CREATE_COURSE",
    payload
});

